import BulkAddToWishlistFlow, {
  type BulkAddToWishlistFlowProps,
} from "~/features/orders/orderDetails/components/AddToWishlist/BulkAddToWishlistFlow";
import { useDispatch } from "react-redux";
import { addOrderDetailsToWishlist } from "~/features/wishlist/redux/actions";
import { type OrderLineItemData } from "~/domains/orders/types/modelsV2";

type SelfProps = Pick<BulkAddToWishlistFlowProps, "onClose"> & {
  selectedOrderItems: OrderLineItemData[];
};

export const OrderDetailsAddToWishlistFlow = ({ onClose, selectedOrderItems }: SelfProps) => {
  const dispatch = useDispatch();

  const handleAddToWishlist = (data: { wishlistId: string } | { wishlistName: string }) => {
    return dispatch(addOrderDetailsToWishlist(data, selectedOrderItems));
  };

  return <BulkAddToWishlistFlow onClose={onClose} onAddToWishlist={handleAddToWishlist} />;
};

export default OrderDetailsAddToWishlistFlow;
